/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} North_Sound_Robin_CommendInputs */

const fr_north_sound_robin_commend = /** @type {(inputs: North_Sound_Robin_CommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu veux suivre tes Records Personnels ?`)
};

/**

* @param {North_Sound_Robin_CommendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const north_sound_robin_commend = /** @type {((inputs?: North_Sound_Robin_CommendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<North_Sound_Robin_CommendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_north_sound_robin_commend(inputs)
});